module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image9-1d8d0a8addd8732a8bac14702d706e81.jpg";